export const KOREA = 'Korea (South)';
export const US = 'United States';
export const CRYPTO = 'Crypto';
export const JAPAN = 'Japan';